import { AsteroidInfo } from '../data/AsteroidData';
import { Mission, MissionPhase } from './MissionTypes';

export function getMissionAsteroidData(
  mission: Pick<Mission, 'asteroidId'>,
  renderedAsteroids: Map<string, AsteroidInfo>,
  allAsteroids: AsteroidInfo[]
): AsteroidInfo | undefined {
  return renderedAsteroids.get(mission.asteroidId)
    ?? allAsteroids.find(asteroid => asteroid.id === mission.asteroidId);
}

export function isMissionSuccessRewardPending(mission: Mission): boolean {
  return mission.currentPhase === MissionPhase.MISSION_SUCCESS && !mission.completionProcessed;
}
